import { User } from "@/models/user.model";
import { AuthRest } from "@/services/rest/auth.rest";
import { defineStore } from "pinia";
import { instance } from "./index";

const store = defineStore({
  id: "auth",
  state: () => ({
    data: new User(),
    isRefreshing: false,
    refreshSubscribers: [] as Array<(token: string) => void>,
  }),
  getters: {
    getData: (state) => {
      const user = state.data;
      if (user) {
        var arrName = user.userName?.split(" ");
        user.firstName = arrName ? arrName[0] : "";
      }
      return user;
    },
  },
  actions: {
    setData(value: User | null) {
      this.data = value!;
      localStorage.setItem("user", JSON.stringify(value));
    },
    loadTokensFromStorage() {
      const auth: User = JSON.parse(localStorage.getItem("user") as string);
      this.data = auth;
    },
    async refreshAccessToken() {
      if (this.isRefreshing) {
        return new Promise<string>((resolve) => {
          this.refreshSubscribers.push(resolve);
        });
      }

      const { refreshToken } = this.data;
      this.isRefreshing = true;

      try {
        if (refreshToken) {
          const newAccessToken = await AuthRest.refresh(refreshToken);
          this.setData({
            ...this.getData,
            accessToken: newAccessToken.accessToken,
            refreshToken: newAccessToken.refreshToken,
          });
          this.refreshSubscribers.forEach((callback) =>
            callback(newAccessToken.accessToken)
          );
          this.refreshSubscribers = [];
          return newAccessToken.accessToken;
        }
      } catch (err) {
        this.refreshSubscribers = [];
        throw err;
      } finally {
        this.isRefreshing = false;
      }
    },
    async logout() {
      const { refreshToken, accessToken } = this.data;
      await AuthRest.logout(refreshToken!, accessToken!);
    },
    reset() {
      localStorage.clear();
      window.location.reload();
      this.$reset();
    },
  },
});

export const useAuthStore = store(instance);
